export default {
  title: 'Erstattungsbetrag eingeben',
  description: 'Verfügbar für Erstattung: {{amount}}',
  form: {
    amount: {
      label: 'Erstatten',
    },
    reason: {
      label: 'Grund',
      options: {
        requested_by_customer: 'vom Kunden gewünscht',
        reclamation: 'Reklamation',
        communication_error: 'Kommunikationsfehler',
        other: 'andere',
      },
    },
    manual_reason: {
      label: 'Erstattungsgrund eingeben',
    },
  },
  feedback: {
    amount_too_small: 'Mindest-Erstattungsbetrag {{amount}}',
    amount_too_big: 'Maximaler Erstattungsbetrag {{amount}}',
    payment_frozen:
      'Rückerstattung wurde bereits vom Kunden angefordert. {{provider}} steht wegen der Rückerstattung in Kontakt mit dem Kunden',
  },
  buttons: {
    refund: 'Erstatten',
    cancel: 'Abbrechen',
  },
  toasts: {
    refund_successful: 'Die Rückerstattung in Höhe von {{amount}} wurde erfolgreich veranlasst!',
  },
};
